export default {
  props: {
    threshold: {
      type: Number,
      default: 1,
    },
    force: {
      type: [Boolean, null],
      default: null,
    },
  },
  data() {
    return {
      inViewInternal: false,
    }
  },
  mounted() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target)
            this.inViewInternal = true
          }
        })
      },
      { threshold: this.threshold }
    )
    observer.observe(this.$el)
  },
  computed: {
    inView() {
      if (typeof this.force === 'boolean') {
        return this.force
      }
      return this.inViewInternal && this.$store.state.animate
    },
  },
}
